"use client";

import { Routes } from "@/api";
import { cn } from "@/lib/utils";
import { ArrowLeftIcon } from "lucide-react";
import { useRouter } from "next/navigation";
import { Button } from "./ui/button";

interface Props {
  readonly onClick?: () => void;
  readonly className?: string;
}

export function BackButton(props: Props) {
  const router = useRouter();

  const goBack = () => {
    const hasPreviousPage = window?.history?.length >= 2;

    if (hasPreviousPage) {
      router.back();
    } else {
      router.replace(Routes.HOME);
    }
  };

  return (
    <Button
      className={cn("size-8 rounded-full", props.className)}
      variant="outline"
      size="icon"
      onClick={props.onClick ?? goBack}
    >
      <ArrowLeftIcon className="size-4" />
    </Button>
  );
}
